import { render } from "./setup-guidelines.vue?vue&type=template&id=3fbbb78a&scoped=true"
import script from "./setup-guidelines.vue?vue&type=script&lang=js"
export * from "./setup-guidelines.vue?vue&type=script&lang=js"

import "./setup-guidelines.vue?vue&type=style&index=0&id=3fbbb78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbbb78a"]])

export default __exports__